import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './styles/fonts.css'
import './styles/mds.scss'
import './styles/design-polish.css'
import './styles/admin-theme.css'
import { useAuthStore } from './stores/authStore.js'
import { userManager, isOidcCallback } from './config/auth.config.js'
import { installGlobalErrorHandlers } from './utils/errorReporter.js'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
installGlobalErrorHandlers(app)

const authStore = useAuthStore()

async function bootstrap() {
  // Okta redirects back to the bare origin ("/?code=...&state=...").
  // Complete the code-for-token exchange BEFORE mounting the app/router,
  // then strip the auth params from the URL and route to the originally
  // requested path (carried via state.redirectTo).
  if (isOidcCallback()) {
    try {
      const oidcUser = await userManager.signinRedirectCallback()
      const target = oidcUser?.state?.redirectTo || '/'
      window.history.replaceState({}, document.title, target)
    } catch (err) {
      console.error('[Auth] OIDC callback failed:', err)
      window.history.replaceState({}, document.title, '/')
    }
  }

  // Hydrate the Pinia store from sessionStorage (silent restore on refresh)
  await authStore.loadUser()

  app.mount('#app')
}

bootstrap()
